/**
 * Created by mnaughton on 10/20/2015.
 */

import BaseFieldView from "core/views/Field/BaseFieldView";
import _ from "underscore";
import s from "underscore.string";
export default BaseFieldView.extend({
  template: _.template('<span data-value="<%-value%>"><%-text%></span>'),

  serialize: function (options) {
    var result = {
      value: options.value,
    };

    if (options.regex) {
      var regex = new RegExp(options.regex, "gi");

      var matches = regex.exec(String(options.value));

      if (matches !== null) {
        matches.shift(); //get rid of the first item, which always includes the entire string
        result.text = options.format;

        _.each(matches, function (value, index) {
          result.text = s.replaceAll(result.text, "\\{" + index + "\\}", value);
        });
      } else {
        result.text = options.value;
      }
    } else {
      //in this case, format should be a function which takes the value and spits out the formatted value
      result.text = options.format(options.value);
    }

    return result;
  },

  getControlValue: function () {
    return this.$("span").data("value");
  },

  setControlValue: function () {
    this.render();
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/core/views/Field/view/FormattedView.js
// module id = 850
// module chunks = 1